import React from 'react';
import { SubmitButton } from '../../../../shared/components';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { useCreateUserAccountFormContext } from './hooks/useCreateUserAccountFormContext';
import { useCreateUserAccountHasRequiredFields } from './hooks/useCreateUserAccountHasRequiredFields';

export const CreateUserAccountSubmit = () => {
	const { t } = useTranslation();
	const { formState } = useCreateUserAccountFormContext();
	const hasRequiredFields = useCreateUserAccountHasRequiredFields();

	const disabled = !hasRequiredFields || formState.isSubmitting;

	return (
		<SubmitButton disabled={disabled}>
			{t('web_parking_confirmation_save_booking_button')}
		</SubmitButton>
	);
};
